<script lang="ts">
  import PageWrapper from "@src/components/PageWrapper.svelte";
  import Row from "@src/components/Row.svelte";
  import NewsSection from "@src/views/NewsSection.svelte";
</script>

<svelte:head>
  <title>Niilon Pojat - Uutiset</title>
</svelte:head>
<PageWrapper fillerColor="gray">
  <Row color="yellow">
    <h1>Uutiset</h1>
    <NewsSection />
  </Row>
  <Row color="gray" filler />
</PageWrapper>
